import apiClient from '../apiClient';
import API from '../../config/api';

/**
 * Settings Service
 * Handles all settings-related API calls
 */

/**
 * Get nomination status (public endpoint)
 * @returns {Promise} Response with nomination status
 */
export const getNominationStatus = async () => {
  try {
    const response = await apiClient.publicApiClient.get(API.settings.nominationStatus);
    return response.data;
  } catch (error) {
    console.error('Error fetching nomination status:', error);
    throw error;
  }
};

/**
 * Set nomination status (admin only)
 * @param {boolean} isOpen - Whether nomination should be open
 * @returns {Promise} Response with updated setting
 */
export const setNominationStatus = async (isOpen) => {
  try {
    // استخدام طريقة POST مع إرسال البيانات في الجسم بدلاً من query parameters
    const response = await apiClient.privateApiClient.post(API.settings.nominationStatus, { is_open: isOpen });
    return response.data;
  } catch (error) {
    console.error('Error setting nomination status:', error);
    throw error;
  }
};

/**
 * Get all settings (admin only)
 * @returns {Promise} Response with all settings
 */
export const getAllSettings = async () => {
  try {
    const response = await apiClient.privateApiClient.get(API.settings.base);
    return response.data;
  } catch (error) {
    console.error('Error fetching all settings:', error);
    throw error;
  }
};

/**
 * Get setting by key (admin only)
 * @param {string} key - Setting key
 * @returns {Promise} Response with setting
 */
export const getSettingByKey = async (key) => {
  try {
    const response = await apiClient.privateApiClient.get(API.settings.getByKey(key));
    return response.data;
  } catch (error) {
    console.error(`Error fetching setting '${key}':`, error);
    throw error;
  }
};

/**
 * Create new setting (admin only)
 * @param {Object} setting - Setting data
 * @returns {Promise} Response with created setting
 */
export const createSetting = async (setting) => {
  try {
    const response = await apiClient.privateApiClient.post(API.settings.base, setting);
    return response.data;
  } catch (error) {
    console.error('Error creating setting:', error);
    throw error;
  }
};

/**
 * Update setting by key (admin only)
 * @param {string} key - Setting key
 * @param {Object} updateData - Update data
 * @returns {Promise} Response with updated setting
 */
export const updateSetting = async (key, updateData) => {
  try {
    const response = await apiClient.privateApiClient.put(API.settings.update(key), updateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating setting '${key}':`, error);
    throw error;
  }
};

/**
 * Delete setting by key (admin only)
 * @param {string} key - Setting key
 * @returns {Promise} Response with deletion result
 */
export const deleteSetting = async (key) => {
  try {
    const response = await apiClient.delete(API.settings.delete(key));
    return response.data;
  } catch (error) {
    console.error(`Error deleting setting '${key}':`, error);
    throw error;
  }
};
